import { Loading } from '@rd-web-markets/shared/dist/util';
import React, { useState, useEffect } from 'react';
import { Form, Card, Row, Button, Col, Tabs, Tab } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import ClaimProjectReportDetailsNavigation from '@rd-web-markets/de/dist/technicalProof/ClaimProjectReportDetailsNavigation';
import firstFastChecksService from '@rd-web-markets/de/dist/services/first_fast_check.service';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { useTranslation } from 'react-i18next';
import Tasks from '../claim_group/technical_proof/Tasks';
import ReasonsForResubmission from './ReasonsForResubmission';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SummarySection from '@rd-web-markets/shared/dist/technicalProof/SummarySection';
import ProjectDocumentsSection from '@rd-web-markets/shared/dist/technicalProof/ProjectDocumentsSection';
import ContactsSection from '@rd-web-markets/shared/dist/technicalProof/ContactsSection';
import * as QueryString from 'query-string';
import ClaimProjectReportFooter from '@/pages/shared/technical_proof/ClaimProjectReportFooter';
import ClaimProjectNotes from '@rd-web-markets/shared/dist/technicalProof/ClaimProjectNotes';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useGetUserClaimGroupAbilities } from '@rd-web-markets/market/dist/userAbilities';
const ClaimProjectReportDetails = _ref => {
  let {
    setClaimGroup,
    accountType,
    claimGroup,
    report,
    company,
    setReport,
    handleToaster,
    handleSubmit,
    handleChange,
    handleDelete,
    handleDateChange,
    handleCheckChange
  } = _ref;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [firstFastCheck, setFirstFastCheck] = useState(null);
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const [isSelectedDifferentClaimGroup, setIsSelectedDifferentClaimGroup] = useState(false);
  const [key, setKey] = useState(QueryString.parse(window.location.search) === '' ? 'summary' : QueryString.parse(window.location.search).query);
  const user = useSelector(state => state.auth.user);
  const userClaimGroupAbilities = useGetUserClaimGroupAbilities(user, claimGroup.id);
  const pageAccess = userClaimGroupAbilities.pages.ClaimProjectReportDetailPage;
  useEffect(() => {
    const fetchData = async () => {
      const firstFastCheck = await firstFastChecksService.get(report.id);
      setFirstFastCheck(firstFastCheck);
    };
    fetchData();
  }, []);
  const onSelectClaimGroup = e => {
    e.target.value != claimGroup.id ? setIsSelectedDifferentClaimGroup(true) : setIsSelectedDifferentClaimGroup(false);
    handleChange(e);
  };
  const handleModalSubmit = () => {
    if (isSelectedDifferentClaimGroup) {
      handleSubmit();
      history.replace(`/${accountType}/companies/${company.id}/master`);
    } else {
      handleToaster('Please select another year to move', 'warning');
    }
  };
  const getClaimGroupName = claimGroup => {
    return claimGroup.name.replace(claimGroup.company.name, '').trim();
  };
  const selectBFSZYearBody = () => {
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Form.Label, {
      column: true,
      md: 4
    }, t('choose_year')), /*#__PURE__*/React.createElement(Form.Control, {
      as: "select",
      name: "claim_group_id",
      size: "md",
      type: "text",
      onChange: onSelectClaimGroup,
      value: report.claim_group_id
    }, company.claim_groups.map(claim_group => /*#__PURE__*/React.createElement("option", {
      key: claim_group.id,
      value: claim_group.id
    }, getClaimGroupName(claim_group)))))));
  };
  if (!firstFastCheck) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(ClaimProjectReportDetailsNavigation, {
    firstFastCheck: firstFastCheck,
    setClaimGroup: setClaimGroup,
    claimGroup: claimGroup,
    report: report,
    page: "general"
  }), /*#__PURE__*/React.createElement(Tasks, {
    report: report,
    setReport: setReport,
    handleToaster: handleToaster
  }), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Modal, {
    show: showModal,
    size: "lg",
    title: t('move_project_to_another_bfsz_year'),
    renderBody: () => selectBFSZYearBody(),
    onHide: () => setShowModal(false),
    closeText: t('close'),
    onSubmit: handleModalSubmit
  }), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-2 row justify-content-end me-0"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowModal(true)
  }, t('move_project_to_another_bfsz_year'))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary"
  }, t('project_report')), /*#__PURE__*/React.createElement("p", null, t('this_could_be_a_separate_project_a_subproject_of_a_bigger_commercial_product_or_a_specific_feature'))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_name')), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    controlAs: "textarea",
    rows: "1",
    onBlur: handleSubmit,
    onChange: handleChange,
    name: "project_name",
    object: report,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_id')), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    rows: "1",
    name: "sequential_number",
    disabled: true,
    object: report,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('kick_off_date')), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: async date => {
      // first set field end_date to chosen date + 1 day to prevent validation error
      const [day, month, year] = date.split('/');
      const end_date = new Date(year, month - 1, day);
      end_date.setDate(end_date.getDate() + 1);
      // change both fields
      await handleDateChange({
        target: {
          value: date,
          name: 'start_date'
        },
        associatedTarget: {
          value: `${end_date.getDate()}/${end_date.getMonth() + 1}/${end_date.getFullYear()}`,
          name: 'end_date'
        }
      });
    },
    selected: report.start_date
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('rapid_claim')), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(Form.Check, {
    checked: report.rapid_claim,
    value: !!report.rapid_claim,
    name: "rapid_claim",
    onChange: handleChange,
    onBlur: handleSubmit
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_code')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "code",
    object: report,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('eligibility_assessment')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "assessment",
    onChange: handleChange,
    size: "md",
    onBlur: handleSubmit,
    value: report.assessment || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), /*#__PURE__*/React.createElement("option", {
    value: "not_started"
  }, t('not_started')), /*#__PURE__*/React.createElement("option", {
    value: "in_progress"
  }, t('in_progress')), /*#__PURE__*/React.createElement("option", {
    value: "completed"
  }, t('completed'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_status')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "completion_status",
    onChange: handleChange,
    onBlur: handleSubmit,
    size: "md",
    value: report.completion_status || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), /*#__PURE__*/React.createElement("option", {
    value: "completion_status_unstarted"
  }, t('not_started')), /*#__PURE__*/React.createElement("option", {
    value: "completion_status_in_progress"
  }, t('in_progress')), /*#__PURE__*/React.createElement("option", {
    value: "completion_status_finished"
  }, t('completed'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('application_type')), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    as: "select",
    value: report.application_type,
    name: "application_type",
    onChange: handleChange,
    onBlur: handleSubmit
  }, ['none_selected', 'new_application', 'resubmission', 'change_request'].map(applicationType => {
    return /*#__PURE__*/React.createElement("option", {
      key: report.id + applicationType,
      value: applicationType
    }, applicationType === 'none_selected' ? t('select_application_type') : t(applicationType));
  })))), /*#__PURE__*/React.createElement(ReasonsForResubmission, {
    shouldRender: report.application_type === 'resubmission',
    report: report,
    handleCheckChange: handleCheckChange,
    handleChange: handleChange,
    handleSubmit: handleSubmit
  }), /*#__PURE__*/React.createElement(Tabs, {
    onSelect: k => setKey(k),
    activeKey: key,
    id: "uncontrolled-tab-example",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "contacts",
    title: t('contacts')
  }, /*#__PURE__*/React.createElement(ContactsSection, {
    setLoading: setLoading,
    setClaimGroup: setClaimGroup,
    report: report,
    claimGroup: claimGroup,
    company: company
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "documents",
    title: t('documents')
  }, /*#__PURE__*/React.createElement(ProjectDocumentsSection, {
    report: report,
    setReport: setReport,
    handleToaster: handleToaster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "notes",
    title: t('notes')
  }, /*#__PURE__*/React.createElement(ClaimProjectNotes, {
    report: report,
    setReport: setReport,
    pageAccess: pageAccess
  }))))));
};
export default ClaimProjectReportDetails;